import React,{useContext,useEffect,useState} from 'react'
import ProjectsContext from '../../contexts/ProjectsContext'
import ProjectCard from '../../components/Cards/ProjectCard'
import Card from '../../components/Cards/Card'
import Text from '../../components/Text/Text'
import Subheading from '../../components/Text/Subheading'
import {useNavigate} from 'react-router-dom'
import ErrorContext from '../../contexts/ErrorContext'
import Loading from '../Loading'
import usePageTitle from '../../hooks/usePageTitle'
import {logEvent} from 'firebase/analytics'
import analytics from '../../helpers/analytics'
import {getUser,rt} from '../../helpers/firebase'
import UserContext from '../../contexts/UserContext'
import {push,ref,update} from 'firebase/database'
import {prodErrorMap} from 'firebase/auth'
import useUserSubscription from '../../hooks/useUserSubscription'
import {useParams} from 'react-router-dom'
import InputHeading from '../../components/Inputs/InputHeading'
import FolderCard from '../../components/Cards/FolderCard'
import Icon from '../../components/Text/Icon'
import HorizontalDivider from '../../components/Dividers/HorizontalDivider'


const newProcessProject={
    title: 'Untitled Process Flow',
    nodes: [
        {
            "width": 140,
            "height": 36,
            "positionAbsolute": {
                "y": 0,
                "x": 10
            },
            "position": {
                "x": 10,
                "y": 0
            },
            "type": "squircleNode",
            "data": {
                "text": "",
                "color": "white"
            },
            "style": {
                "width": 140
            },
            "selected": false,
            "id": "aWXtm8E05ozVlL1A3RRy7",
            "dragging": false
        },
        {
            "width": 140,
            "position": {
                "x": -190,
                "y": 70
            },
            "selected": false,
            "height": 36,
            "positionAbsolute": {
                "y": 70,
                "x": -190
            },
            "type": "squircleNode",
            "id": "2gEsEZBZ6zjAnlkMIaSiX",
            "data": {
                "text": "",
                "color": "green"
            },
            "dragging": false,
            "style": {
                "width": 140
            }
        },
        {
            "selected": false,
            "position": {
                "x": -190,
                "y": -70
            },
            "dragging": false,
            "data": {
                "text": "",
                "color": "green"
            },
            "width": 140,
            "positionAbsolute": {
                "y": -70,
                "x": -190
            },
            "type": "squircleNode",
            "height": 36,
            "style": {
                "width": 140
            },
            "id": "i6NO9MVbjUxRsA2wYoFQa"
        },
        {
            "position": {
                "x": 200,
                "y": -100
            },
            "style": {
                "width": 140
            },
            "height": 36,
            "positionAbsolute": {
                "x": 200,
                "y": -100
            },
            "data": {
                "color": "green",
                "text": ""
            },
            "width": 140,
            "dragging": false,
            "type": "rectNode",
            "id": "cO3EFNY2WEZ9JwJ1cbiF7",
            "selected": false
        },
        {
            "data": {
                "text": "",
                "color": "green"
            },
            "selected": false,
            "id": "ZFoAjeZsDbovYNI6ymUeS",
            "dragging": false,
            "position": {
                "y": 30,
                "x": 200
            },
            "style": {
                "width": 140
            },
            "positionAbsolute": {
                "x": 200,
                "y": 30
            },
            "height": 83,
            "width": 140,
            "type": "diamondNode"
        },
        {
            "positionAbsolute": {
                "x": 400,
                "y": 10
            },
            "position": {
                "x": 400,
                "y": 10
            },
            "data": {
                "color": "white",
                "text": ""
            },
            "height": 36,
            "id": "R-SKxH1v7vrDB6tSyeGKB",
            "width": 140,
            "selected": false,
            "type": "rectNode",
            "dragging": false,
            "style": {
                "width": 140
            }
        },
        {
            "id": "6ZtrZrF2v016roLEQO_LQ",
            "width": 140,
            "height": 36,
            "data": {
                "text": "",
                "color": "white"
            },
            "positionAbsolute": {
                "x": 400,
                "y": 130
            },
            "dragging": false,
            "type": "rectNode",
            "style": {
                "width": 140
            },
            "selected": false,
            "position": {
                "x": 400,
                "y": 130
            }
        }
    ],
    edges: [
        {
            "markerEnd": {
                "color": "rgba(0,0,0,0)",
                "type": "arrowclosed"
            },
            "markerStart": {
                "color": "rgba(0,0,0,0)",
                "type": "arrowclosed"
            },
            "source": "i6NO9MVbjUxRsA2wYoFQa",
            "targetHandle": "aWXtm8E05ozVlL1A3RRy7d",
            "id": "reactflow__edge-i6NO9MVbjUxRsA2wYoFQai6NO9MVbjUxRsA2wYoFQad-aWXtm8E05ozVlL1A3RRy7aWXtm8E05ozVlL1A3RRy7c",
            "sourceHandle": "i6NO9MVbjUxRsA2wYoFQab",
            "target": "aWXtm8E05ozVlL1A3RRy7"
        },
        {
            "sourceHandle": "2gEsEZBZ6zjAnlkMIaSiXb",
            "markerEnd": {
                "color": "rgba(0,0,0,0)",
                "type": "arrowclosed"
            },
            "targetHandle": "aWXtm8E05ozVlL1A3RRy7d",
            "id": "reactflow__edge-2gEsEZBZ6zjAnlkMIaSiX2gEsEZBZ6zjAnlkMIaSiXd-aWXtm8E05ozVlL1A3RRy7aWXtm8E05ozVlL1A3RRy7c",
            "markerStart": {
                "type": "arrowclosed",
                "color": "rgba(0,0,0,0)"
            },
            "source": "2gEsEZBZ6zjAnlkMIaSiX",
            "target": "aWXtm8E05ozVlL1A3RRy7"
        },
        {
            "markerEnd": {
                "type": "arrowclosed",
                "color": "rgba(0,0,0,0)"
            },
            "id": "reactflow__edge-aWXtm8E05ozVlL1A3RRy7aWXtm8E05ozVlL1A3RRy7d-cO3EFNY2WEZ9JwJ1cbiF7cO3EFNY2WEZ9JwJ1cbiF7c",
            "source": "aWXtm8E05ozVlL1A3RRy7",
            "targetHandle": "cO3EFNY2WEZ9JwJ1cbiF7d",
            "markerStart": {
                "type": "arrowclosed",
                "color": "rgba(0,0,0,0)"
            },
            "target": "cO3EFNY2WEZ9JwJ1cbiF7",
            "sourceHandle": "aWXtm8E05ozVlL1A3RRy7b"
        },
        {
            "target": "ZFoAjeZsDbovYNI6ymUeS",
            "sourceHandle": "aWXtm8E05ozVlL1A3RRy7b",
            "id": "reactflow__edge-aWXtm8E05ozVlL1A3RRy7aWXtm8E05ozVlL1A3RRy7d-ZFoAjeZsDbovYNI6ymUeSZFoAjeZsDbovYNI6ymUeSc",
            "markerStart": {
                "color": "rgba(0,0,0,0)",
                "type": "arrowclosed"
            },
            "targetHandle": "ZFoAjeZsDbovYNI6ymUeSd",
            "source": "aWXtm8E05ozVlL1A3RRy7",
            "markerEnd": {
                "color": "rgba(0,0,0,0)",
                "type": "arrowclosed"
            }
        },
        {
            "targetHandle": "R-SKxH1v7vrDB6tSyeGKBd",
            "markerEnd": {
                "type": "arrowclosed",
                "color": "rgba(0,0,0,0)"
            },
            "sourceHandle": "ZFoAjeZsDbovYNI6ymUeSb",
            "target": "R-SKxH1v7vrDB6tSyeGKB",
            "source": "ZFoAjeZsDbovYNI6ymUeS",
            "id": "reactflow__edge-ZFoAjeZsDbovYNI6ymUeSZFoAjeZsDbovYNI6ymUeSd-R-SKxH1v7vrDB6tSyeGKBR-SKxH1v7vrDB6tSyeGKBc",
            "markerStart": {
                "type": "arrowclosed",
                "color": "rgba(0,0,0,0)"
            }
        },
        {
            "targetHandle": "6ZtrZrF2v016roLEQO_LQd",
            "target": "6ZtrZrF2v016roLEQO_LQ",
            "sourceHandle": "ZFoAjeZsDbovYNI6ymUeSc",
            "id": "reactflow__edge-ZFoAjeZsDbovYNI6ymUeSZFoAjeZsDbovYNI6ymUeSb-6ZtrZrF2v016roLEQO_LQ6ZtrZrF2v016roLEQO_LQc",
            "markerStart": {
                "color": "rgba(0,0,0,0)",
                "type": "arrowclosed"
            },
            "source": "ZFoAjeZsDbovYNI6ymUeS",
            "markerEnd": {
                "color": "rgba(0,0,0,0)",
                "type": "arrowclosed"
            }
        }
    ],
    gridScale: 10,
    chats: [],
    files: [],
    public: false,
    updatedAt: Date.now(),
}

const newMindMapProject={
    title: 'Untitled Mind Map',
    nodes: [
        {
            "style": {
                "width": 140
            },
            "dragging": false,
            "width": 140,
            "type": "squircleNode",
            "height": 36,
            "position": {
                "x": 260,
                "y": 10
            },
            "data": {
                "text": ""
            },
            "positionAbsolute": {
                "y": 10,
                "x": 260
            },
            "selected": false,
            "id": "s5z7hDeWR0bvipfDJ0wA8"
        },
        {
            "width": 140,
            "type": "squircleNode",
            "dragging": false,
            "positionAbsolute": {
                "x": 70,
                "y": 150
            },
            "height": 36,
            "id": "6c86LjYuNIq1bqHzep2XK",
            "style": {
                "width": 140
            },
            "data": {
                "text": ""
            },
            "selected": false,
            "position": {
                "x": 70,
                "y": 150
            }
        },
        {
            "style": {
                "width": 140
            },
            "dragging": false,
            "position": {
                "y": 50,
                "x": 70
            },
            "positionAbsolute": {
                "y": 50,
                "x": 70
            },
            "id": "5JShBBPpewdzVN7Sftp5_",
            "width": 140,
            "height": 36,
            "selected": false,
            "data": {
                "text": ""
            },
            "type": "squircleNode"
        },
        {
            "data": {
                "color": "green",
                "text": ""
            },
            "selected": false,
            "id": "f1CdUv4SmxY1TpkgOe2zT",
            "style": {
                "width": 140
            },
            "position": {
                "y": 100,
                "x": -110
            },
            "positionAbsolute": {
                "y": 100,
                "x": -110
            },
            "type": "squircleNode",
            "height": 36,
            "width": 140,
            "dragging": false
        },
        {
            "dragging": false,
            "position": {
                "x": 260,
                "y": 150
            },
            "width": 140,
            "style": {
                "width": 140
            },
            "type": "squircleNode",
            "selected": false,
            "data": {
                "text": ""
            },
            "positionAbsolute": {
                "y": 150,
                "x": 260
            },
            "id": "6x-1X-x1MhVWCthTxg-DP",
            "height": 36
        },
        {
            "id": "lFQZEP_ZzQlCtOalTh6ol",
            "height": 36,
            "positionAbsolute": {
                "x": 260,
                "y": 70
            },
            "selected": false,
            "width": 140,
            "type": "squircleNode",
            "dragging": false,
            "style": {
                "width": 140
            },
            "position": {
                "x": 260,
                "y": 70
            },
            "data": {
                "text": "",
                "color": "green"
            }
        }
    ],
    edges: [
        {
            "target": "bye",
            "source": "hello",
            "id": "hello-bye",
            "type": "simplebezier"
        },
        {
            "id": "reactflow__edge-f1CdUv4SmxY1TpkgOe2zTf1CdUv4SmxY1TpkgOe2zTd-5JShBBPpewdzVN7Sftp5_5JShBBPpewdzVN7Sftp5_c",
            "sourceHandle": "f1CdUv4SmxY1TpkgOe2zTb",
            "target": "5JShBBPpewdzVN7Sftp5_",
            "markerStart": {
                "type": "arrowclosed",
                "color": "rgba(0,0,0,0)"
            },
            "targetHandle": "5JShBBPpewdzVN7Sftp5_d",
            "markerEnd": {
                "color": "rgba(0,0,0,0)",
                "type": "arrowclosed"
            },
            "source": "f1CdUv4SmxY1TpkgOe2zT"
        },
        {
            "sourceHandle": "f1CdUv4SmxY1TpkgOe2zTb",
            "targetHandle": "6c86LjYuNIq1bqHzep2XKd",
            "target": "6c86LjYuNIq1bqHzep2XK",
            "source": "f1CdUv4SmxY1TpkgOe2zT",
            "id": "reactflow__edge-f1CdUv4SmxY1TpkgOe2zTf1CdUv4SmxY1TpkgOe2zTd-6c86LjYuNIq1bqHzep2XK6c86LjYuNIq1bqHzep2XKc",
            "markerStart": {
                "type": "arrowclosed",
                "color": "rgba(0,0,0,0)"
            },
            "markerEnd": {
                "type": "arrowclosed",
                "color": "rgba(0,0,0,0)"
            }
        },
        {
            "target": "s5z7hDeWR0bvipfDJ0wA8",
            "sourceHandle": "5JShBBPpewdzVN7Sftp5_b",
            "targetHandle": "s5z7hDeWR0bvipfDJ0wA8d",
            "markerEnd": {
                "type": "arrowclosed",
                "color": "rgba(0,0,0,0)"
            },
            "markerStart": {
                "color": "rgba(0,0,0,0)",
                "type": "arrowclosed"
            },
            "id": "reactflow__edge-5JShBBPpewdzVN7Sftp5_5JShBBPpewdzVN7Sftp5_d-s5z7hDeWR0bvipfDJ0wA8s5z7hDeWR0bvipfDJ0wA8c",
            "source": "5JShBBPpewdzVN7Sftp5_"
        },
        {
            "target": "lFQZEP_ZzQlCtOalTh6ol",
            "markerStart": {
                "type": "arrowclosed",
                "color": "rgba(0,0,0,0)"
            },
            "markerEnd": {
                "type": "arrowclosed",
                "color": "rgba(0,0,0,0)"
            },
            "source": "5JShBBPpewdzVN7Sftp5_",
            "sourceHandle": "5JShBBPpewdzVN7Sftp5_b",
            "targetHandle": "lFQZEP_ZzQlCtOalTh6old",
            "id": "reactflow__edge-5JShBBPpewdzVN7Sftp5_5JShBBPpewdzVN7Sftp5_d-lFQZEP_ZzQlCtOalTh6ollFQZEP_ZzQlCtOalTh6olc"
        },
        {
            "markerStart": {
                "type": "arrowclosed",
                "color": "rgba(0,0,0,0)"
            },
            "target": "6x-1X-x1MhVWCthTxg-DP",
            "id": "reactflow__edge-6c86LjYuNIq1bqHzep2XK6c86LjYuNIq1bqHzep2XKd-6x-1X-x1MhVWCthTxg-DP6x-1X-x1MhVWCthTxg-DPc",
            "markerEnd": {
                "type": "arrowclosed",
                "color": "rgba(0,0,0,0)"
            },
            "source": "6c86LjYuNIq1bqHzep2XK",
            "targetHandle": "6x-1X-x1MhVWCthTxg-DPd",
            "sourceHandle": "6c86LjYuNIq1bqHzep2XKb"
        }
    ],
    gridScale: 10,
    chats: [],
    files: [],
    public: false,
    updatedAt: Date.now(),
}

export default function Projects() {
    const [pageTitle,setPageTitle]=usePageTitle('Projects')

    const {folderId}=useParams()
    const [projects,updateProjects,folders]=useContext(ProjectsContext)
    const [projectLoading,setProjectLoading]=useState(false)
    const [user]=useContext(UserContext)
    const [loading,setLoading]=useState(false)
    const {getUserPlan}=useUserSubscription()
    const setError=useContext(ErrorContext)
    const navigate=useNavigate()
    const [folderName,setFolderName]=useState('')
    const [rightClickMenuDetails,setRightClickMenuDetails]=useState({
        visible: false,
        x: 0,
        y: 0,
        id: null
    })

    useEffect(() => {
        setFolderName(folders.find(folder => folder.id===folderId)?.title)
    },[folderId,folders])

    useEffect(() => {
        updateProjects()
    },[updateProjects])

    if(loading) {
        return <Loading inline />
    }

    const handleCreateProject=async (projectType) => {
        if(projectLoading) return;
        setProjectLoading(true)
        let newProject
        if(projectType==='process') {
            newProject=newProcessProject
        } else if(projectType==='mindmap') {
            newProject=newMindMapProject
        } else {
            newProject={
                title: 'Untitled Flowchart',
                nodes: [],
                edges: [],
                files: [],
                chats: [],
                gridScale: 10,
                public: false,
                updatedAt: Date.now(),
            }
        }
        const ownProjects=projects.filter(project => project.ownerId===user.uid)
        const userPlan=await getUserPlan()
        if((userPlan==='free'&&ownProjects.length>=5)) {
            setError('You have reached the maximum number of projects allowed on your plan')
            navigate('/pricing')
            return
        }
        return push(ref(rt,'projects/'+user.uid),{folder: folderId||null,...newProject}).then(data => {
            setProjectLoading(false)
            const projectId=data.key
            if(data) {
                logEvent(analytics,'new_project',{
                    project_id: projectId
                })
                setLoading(true)
                updateProjects();
                setLoading(false)
                navigate('/dashboard/design/'+projectId)
            } else {
                logEvent(analytics,'new_project_error')
            }
        })
    }

    const handleShowRightClickMenu=(e,id) => {
        // Handle Case when right click is oustide screen bounds
        e.preventDefault()
        e.stopPropagation()
        setRightClickMenuDetails({
            visible: true,
            x: e.pageX-50,
            y: e.pageY-350,
            id: id
        })
    }

    const handleCreateFolder=async () => {
        if(projectLoading) return;
        setProjectLoading(true)
        return push(ref(rt,'folders/'+user.uid),{
            title: 'Untitled Folder',
            updatedAt: Date.now()
        }).then(data => {
            setProjectLoading(false)
            const folderId=data.key
            if(data) {
                logEvent(analytics,'new_folder',{
                    folder_id: folderId
                })
                setLoading(true)
                updateProjects();
                setLoading(false)
                navigate('/dashboard/'+folderId)
            } else {
                logEvent(analytics,'new_folder_error')
            }
        })
    }

    const handleRenameFolder=async () => {
        if(folderId) {
            if(folderName.length>50) {
                setError('Folder name must be less than 50 characters')
                return
            }
            const folderRef=ref(rt,'folders/'+user.uid+'/'+folderId)
            update(folderRef,{title: folderName.trim()||'Untitled Folder'})
            updateProjects()
        }
    }

    const handleMoveToFolder=async (projectId,folderId) => {
        if(projectLoading) return;
        setProjectLoading(true)
        const projectRef=ref(rt,'projects/'+user.uid+'/'+projectId)
        update(projectRef,{folder: folderId})
        setRightClickMenuDetails({
            visible: false,
            x: 0,
            y: 0,
            id: null
        })
        setProjectLoading(false)
        updateProjects()
    }

    const handleDeleteProject=async (projectId) => {
        if(window.confirm('Are you sure you want to delete this project?')) {
            if(projectLoading) return;
            setProjectLoading(true)
            const projectRef=ref(rt,'projects/'+user.uid+'/'+projectId)
            update(projectRef,null)
            setRightClickMenuDetails({
                visible: false,
                x: 0,
                y: 0,
                id: null
            })
            setProjectLoading(false)
            updateProjects()
        }
    }

    // How should the right click menu be closed when clicking outside of it?
    // Answer: The right click menu should be closed when clicking outside of it by setting the visible property to false in the state.
    // How to implement: 

    const handleCloseRightClickMenu=(e) => {
        if(e.target.closest('.absolute')) {
            return;
        }
        setRightClickMenuDetails({
            visible: false,
            x: 0,
            y: 0,
            id: null
        })
    }

    return (
        <div className='w-full p-2' onClick={handleCloseRightClickMenu} >
            <div className="flex flex-col items-center justify-center max-w-6xl min-w-full gap-10 px-0 lg:min-w-full md:px-10 lg:px-8 xl:px-8 md:w-128 lg:w-auto lg:pt-10">
                <div className="w-full">
                    <div className="grid w-full grid-cols-1 gap-2 mt-5 sm:grid-cols-3 lg:w-2/3 lg:gap-2">
                        <Card
                            onClick={() => handleCreateProject()}
                            className="flex !justify-start items-center !flex-row gap-1">
                            <i className={`leading-6 align-middle bi ${projectLoading? 'animate-spin bi-bounding-box-circles text-xl':'bi-plus text-2xl'}`}></i>
                            <Text className="!align-middle font-medium">New Project</Text>
                        </Card>
                        <Card
                            onClick={() => handleCreateProject('process')}
                            className="flex !justify-start items-center !flex-row gap-1">
                            <i className="text-xl leading-6 align-middle bi bi-bounding-box-circles"></i>
                            <Text className="!align-middle font-medium">New Process Flow</Text>
                        </Card>
                        <Card
                            onClick={() => handleCreateProject('mindmap')}
                            className="flex !justify-start items-center !flex-row gap-1">
                            <i className="text-2xl leading-6 align-middle bi bi-diagram-2"></i>
                            <Text className="!align-middle font-medium">
                                New Mind Map
                            </Text>
                        </Card>
                    </div>
                </div>
                <div className="w-full">
                    <div className='flex items-center justify-between pb-2 border-b border-b-primary-400'>
                        <Subheading className="">
                            <span className={folderId&&'cursor-pointer'} onClick={() => {
                                if(folderId) {
                                    navigate('/dashboard')
                                }
                            }}>My Projects</span>
                            {folderId&&
                                <>
                                    <span className="px-1 pl-2 text-xl text-zinc-400">
                                        /</span>
                                    <form className='inline font-semibold' onSubmit={(e) => {e.preventDefault(); handleRenameFolder(); e.target.firstChild.blur()}}><InputHeading className='!text-xl !px-1' onBlur={handleRenameFolder} value={folderName} setValue={setFolderName} /></form>
                                </>
                            }
                        </Subheading>
                        <Card className="!flex !flex-row items-center justify-center p-2 rounded-lg cursor-pointer bg-primary-400" onClick={() => handleCreateFolder()}>
                            <i className="text-2xl text-dark bi bi-plus"></i>
                            Create Folder
                        </Card>
                    </div>
                    <div className="relative grid w-full min-w-0 min-h-0 grid-cols-1 gap-4 pb-8 mt-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 lg:gap-3">
                        {/* Right Click Menu should include options to open, move to folder, delete. Move to folder should expand to the right to show all folders. */}
                        {rightClickMenuDetails.visible&&<div className="absolute z-50 p-2 rounded-lg shadow-md bg-light" style={{top: rightClickMenuDetails.y,left: rightClickMenuDetails.x}}>
                            <Text className="!cursor-pointer" onClick={() => navigate('/dashboard/design/'+rightClickMenuDetails.id)}>Open</Text>
                            <HorizontalDivider className='!px-1 !my-2' />
                            {folderId&&
                                <Text className="!cursor-pointer" onClick={() => handleMoveToFolder(rightClickMenuDetails.id,null)}>Move to Home</Text>}
                            {!folderId&&folders.map((folder) => {
                                return <Text key={folder.id} className="!cursor-pointer" onClick={() => handleMoveToFolder(rightClickMenuDetails.id,folder.id)}>Move to <span className='font-semibold'>{folder.title}</span></Text>
                            }
                            )}
                            <HorizontalDivider className='!px-1 !my-2' />
                            <Text className="!cursor-pointer !text-red-600" onClick={() => handleDeleteProject(rightClickMenuDetails.id)}>Delete</Text>
                        </div>}
                        {
                            !folderId&&
                            folders.map((folder) => {
                                return <FolderCard
                                    key={folder.id}
                                    folder={folder}
                                    to={`/dashboard/${folder.id}`}
                                />
                            })
                        }
                        {/* 5.3.1 — Empty state */}
                        {projects.filter(p=>folderId?p.folder===folderId:!p.folder).length===0&&folders.filter(f=>!folderId).length===0&&!loading&&(
                            <div className='col-span-full flex flex-col items-center justify-center py-16 gap-4 text-center'>
                                <div className='w-20 h-20 rounded-2xl bg-primary-50 border-2 border-dashed border-primary-200 flex items-center justify-center'>
                                    <i className='bi bi-diagram-3 text-4xl text-primary-400'></i>
                                </div>
                                <div>
                                    <Subheading className='!text-lg font-semibold text-dark/70'>No projects yet</Subheading>
                                    <Text className='text-sm text-dark-400 mt-1'>Create your first flowchart to get started.</Text>
                                </div>
                                <button
                                    onClick={()=>handleCreateProject()}
                                    className='flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-white rounded-lg bg-primary hover:bg-primary-600 transition-colors shadow-sm'
                                >
                                    <i className='bi bi-plus-circle'></i>
                                    Create your first project
                                </button>
                            </div>
                        )}
                        {
                            projects.map((project) => {
                                if((folderId&&project.folder!==folderId)||(!folderId&&project.folder)) {
                                    return null
                                }
                                return <ProjectCard
                                    onContextMenu={(e) => handleShowRightClickMenu(e,project.id)}
                                    to={`/dashboard/design/${project.link}`}
                                    key={project.id}
                                    project={project}
                                />
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
